// Keep in sync with app/lib/enums/influence_status.py
const InfluenceStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
};

const InfluenceStatusOptions = [
  { value: InfluenceStatus.DRAFT, label: 'Draft' },
  { value: InfluenceStatus.ACTIVE, label: 'Active' },
];

export { InfluenceStatus, InfluenceStatusOptions };
